import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import { richTextValidation } from "@validations/utils";

export const INITIATE_PROMOTION = FORM_FIELDS.INITIATE_PROMOTION;
export const CURRENT_POSITION = INITIATE_PROMOTION.CURRENT_POSITION;
export const RECOMMENDED_POSITION = INITIATE_PROMOTION.RECOMMENDED_POSITION;
export const PROMOTION_SCORE = INITIATE_PROMOTION.PROMOTION_SCORE;
export const SUPPORTING_DOCUMENT = INITIATE_PROMOTION.SUPPORTING_DOCUMENT;
export const LETTER = INITIATE_PROMOTION.LETTER;
export const INITIATE_MODAL = INITIATE_PROMOTION.INITIATE_MODAL;
export const RECOMMEND_MODAL = INITIATE_PROMOTION.RECOMMEND_MODAL;
export const ACTION_MODAL = INITIATE_PROMOTION.ACTION_MODAL;

export const initiatePromotionFormValidation = yup.object().shape({
  // [RECOMMENDED_POSITION.POSTING]: yup
  //   .string()
  //   .required("Recommended Posting is Required"),
  [RECOMMENDED_POSITION.GRADE]: yup
    .number()
    .required("Recommended Grade is Required"),
  [RECOMMENDED_POSITION.DEPARTMENT]: yup
    .number()
    .required("Recommended Department is Required"),
  [RECOMMENDED_POSITION.POST]: yup
    .number()
    .required("Recommended Post is Required"),
  [RECOMMENDED_POSITION.GRADE]: yup
    .number()
    .required("Recommended Grade is Required"),
  [RECOMMENDED_POSITION.POSITION]: yup
    .number()
    .required("Recommended Position is Required"),
  [RECOMMENDED_POSITION.JOINING_DATE]: yup
    .string()
    .required("Joining Date is Required"),
  [PROMOTION_SCORE]: yup
    .string()
    .required("Promotion Examination Score is Required"),

  // [RECOMMENDED_POSITION.BASIC_SALARY]: yup
  //   .number()
  //   .min(0, "Basic salary can't be negative")
  //   .typeError("Basic salary must be a number"),
});

export type InitiatePromotionFormValidationDataType = yup.InferType<
  typeof initiatePromotionFormValidation
>;

// final form
// export const initiatePromotionSubmitFormValidation = yup.object().shape({
//   [LETTER]: richTextValidation(),
// });

// export type InitiatePromotionSubmitFormDataType = yup.InferType<
//   typeof initiatePromotionSubmitFormValidation
// >;
